export default "__VITE_ASSET__spB4S_8y__"